module.exports = require("!!vue-loader!../../node_modules/v-markdown-loader/_cache/index-7.vue");


//////////////////
// WEBPACK FOOTER
// ./en/lab/index.md
// module id = 114
// module chunks = 1